import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "@/styles/app.scss";
import VueSelect from "vue-select";
import noauth from "./axios/noauth";
import auth from "./axios/auth";
import { initAuth, getAuth0 } from "@/auth/auth0";

Vue.use(Element, { locale });
Vue.component("v-select", VueSelect);

Vue.config.productionTip = false;

Vue.prototype.$logout = () => {
  store.commit("user/logout");
  router.push({ name: "index" });
};

Vue.prototype.$noauth = noauth;
Vue.prototype.$http = auth;

async function bootstrap() {
  console.log("🚀 Bootstrapping app...");

  // 1. Init Auth0
  await initAuth();
  const auth0 = getAuth0();

  try {
    /**
     * 2. Handle redirect (after Auth0 login)
     */
    if (window.location.search.includes("code=")) {
      console.log("🔁 Handling Auth0 redirect...");

      const { appState } = await auth0.handleRedirectCallback();

      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);

      /**
       * ✅ Get ACCESS TOKEN (NOT id_token)
       * IMPORTANT: audience must match backend API identifier
       */
      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_APP_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (redirect flow)");

      /**
       * ✅ Call backend login
       */
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/elite/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Backend login failed");
      }

      const data = await response.json();

      /**
       * ✅ Save backend tokens (StatEdge tokens)
       */
      store.commit("user/login", data);

      /**
       * ✅ Redirect user
       */
      router.replace(appState?.target || "/");
    }

    /**
     * 3. Existing session (page refresh case)
     */
    const isAuthenticated = await auth0.isAuthenticated();
    console.log("isAuthenticated:", isAuthenticated);

    if (isAuthenticated && !store.state.user?.isLoggedIn) {
      console.log("♻️ Restoring session...");

      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_APP_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (silent)");

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/elite/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Backend login failed (silent)");
      }

      const data = await response.json();

      store.commit("user/login", data);
    }
  } catch (err) {
    console.error("❌ Auth error:", err);
  }

  /**
   * 4. Start Vue app (ONLY ONCE)
   */
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

/* ---------------- START APP ---------------- */
bootstrap();
